window.Home = window.Home || {};

const setDialogFields = (dialogEl, dialogData) => {
  if (!dialogData) return;
  if (dialogData.explainerText) {
    dialogEl.querySelector('.dialogExplainer').innerHTML = dialogData.explainerText;
  }
  if (dialogData.redirectPage) {
    const aTags = dialogEl.querySelectorAll('a');
    aTags.forEach(a => { a.href = a.dataset.href.replace(/redirectPage/, encodeURIComponent(dialogData.redirectPage)) });
  }
};

const showDialog = async (dialogId, triggerElement, ready, dialogData) => {
  const dialogEl = document.querySelector('#' + dialogId);
  if (dialogData) {
    setDialogFields(dialogEl, dialogData);
  }
  await ready;
  if (dialogEl) {
    dialogEl.open({ 'focusBackElement': triggerElement, 'attachToElement': triggerElement });
    window.Home.dialogDependenciesLoaded = true;
  }
};

window.Home.showDialog = showDialog;
window.Home.dialogDependenciesLoaded = false;
